var _defs, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwdArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      pointerEvents: "bounding-box"
    },
    id: "fwd_arrow",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.32 29.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:white;stroke:#231f20;stroke-miterlimit:10;stroke-width:2px;cursor:pointer;pointer-events:visible;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0.57 28.82 20.57 14.82 0.57 0.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwdArrow);
export default __webpack_public_path__ + "static/media/fwd_arrow.c31b846f9a1a5007bd0a19821fe516d0.svg";
export { ForwardRef as ReactComponent };